export default __webpack_public_path__ + "static/media/upi.bbc82579.svg";